export default __webpack_public_path__ + "static/media/icon_transfer_active_new.8fff634c.svg";